import React from "react";
import { motion } from "framer-motion";

const Journey = () => {
    return (
        <section className="flex justify-between px-0 py-20 mx-auto my-0 max-w-screen-xl max-md:flex-col max-md:gap-8 max-md:px-5 max-md:py-10 max-sm:px-4 max-sm:py-8">
            <motion.h2
                className="text-4xl font-bold text-black leading-[50.4px] w-[526px] max-md:w-full max-md:text-4xl max-md:leading-10 max-sm:text-3xl max-sm:leading-8"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                Our Journey and Values
            </motion.h2>
            <motion.p className="text-lg leading-7 text-black w-[610px] max-md:w-full max-md:text-base max-md:leading-6 max-sm:text-sm max-sm:leading-5 text-justify"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                iExcel International English has been a leader in language education for
                over 20 years, dedicated to providing exceptional English tuition for
                students aged 5 to 18. Our mission is to empower students with the
                necessary language skills for academic success and effective
                communication in a globalized world. We value excellence in education,
                flexibility in learning, and respect for diverse learning needs. Our
                experienced team, including instructors
                is committed to fostering a supportive environment where every
                student can thrive and excel in their English language journey.
            </motion.p>
        </section>
    );
}

export default Journey;